<template>
  <div id="app">
    <Nav></Nav>
    <router-view class="main-content"></router-view>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Nav from './components/Nav';
import Bottom from './components/Bottom';
export default {
  name: 'app',
  components: {
    Nav,
    Bottom,
  }
}
</script>

<style lang="less">
@import url('./assets/style/common.less');
@import url('./assets/style/colors.less');
html,body{
  margin:0;
  padding:0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  margin: 0 auto;
  background-image: url('https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/all_bg.png');
  background-size: 100%;
  background-repeat: round;
  overflow-x: hidden;
}
.el-submenu__title{
  height: 50px;
}
@media screen and (max-width: 992px) {
  html,body{
    width: 100%;
    height: 100%;
    background-image: url('https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/all_bg.png');
  }
  #app {
    // height: 100%;
    background-repeat: initial;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue